module.exports = __webpack_public_path__ + "static/media/1_CONNECTED TO CATS-EYES BRACELET_EN.9e607755.txt";